import { GooglePlacesDataService } from "@/dataservice";

const GooglePlacesController = {
  autocomplete(input, options = {}) {
    return GooglePlacesDataService.autocomplete(input, options);
  },

  getPlaceDetails(placeId, options = {}) {
    return GooglePlacesDataService.getPlaceDetails(placeId, options);
  }
};

export default GooglePlacesController;
